import { lazy, Suspense, type ComponentType } from 'react'
import { useDevPanelShortcut } from './useDevPanelShortcut'

interface DevFlagPanelProps {
    isOpen: boolean
    onClose: () => void
}

const IS_DEV_TOOLING_BUILD = import.meta.env.DEV || import.meta.env.VITE_ENV === 'dev'

let LazyDevFlagPanel: ComponentType<DevFlagPanelProps> | undefined

if (IS_DEV_TOOLING_BUILD) {
    LazyDevFlagPanel = lazy(() => import('./DevFlagPanel'))
}

export function DevPanelMount() {
    if (!IS_DEV_TOOLING_BUILD) return null
    return <DevPanelMountInner />
}

function DevPanelMountInner() {
    const { isOpen, close } = useDevPanelShortcut()
    if (!isOpen || !LazyDevFlagPanel) return null
    const Panel = LazyDevFlagPanel
    return (
        <Suspense fallback={null}>
            <Panel isOpen={isOpen} onClose={close} />
        </Suspense>
    )
}
